import React, { useMemo } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';
import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { shareInstagram } from 'src/app/shared/share/instagram';

import type { ShareActionComponentPropsWithOptions } from '../types';

import { useEducationModal } from './useEducationModal';

// TODO migrate to new DS modal component
export const InstagramShare: React.FC<ShareActionComponentPropsWithOptions> = ({
	children,
	options,
	onAfterAction,
	onBeforeAction,
}) => {
	const openEducationModal = useEducationModal();
	const track = useTracking();
	const utilityContext = useUtilityContext();

	const onClick = useMemo(() => {
		return () => {
			void (async () => {
				await onBeforeAction?.();
				const {
					url,
					trackingData,
					trackingEventName,
					config: { isSunriseEnabled },
				} = options;
				const success = await shareInstagram(
					url,
					{
						trackingData,
						trackingEvents: {
							success: trackingEventName,
							intent: 'instagram_share_story_modal_view',
							continue: 'instagram_share_story_modal_continue',
							cancel: 'instagram_share_story_modal_close',
						},
						openEducationModal: () => openEducationModal({ isSunriseEnabled: !!isSunriseEnabled }),
					},
					track,
					utilityContext.i18n,
				);
				await onAfterAction?.(success);
			})();
		};
	}, [onBeforeAction, onAfterAction, options, openEducationModal, track, utilityContext]);

	return React.cloneElement(children, {
		...children.props,
		onClick,
	});
};
